import type { ClassNames as DayPickerClassNames } from 'react-day-picker';

import { cn } from '~/lib/cn';
import { variants } from '~/lib/variants';

export const chevron = variants({
  base: ['mx-sm', 'transition-transform', 'absolute', 'right-sm'],
  variants: {
    state: {
      default: ['transform', 'rotate-0'],
      open: ['transform', 'rotate-180'],
    },
  },
});

export const dayPickerClassNames: Partial<DayPickerClassNames> = {
  root: cn('w-full px-md py-0 shadow-lg bg-level-02'),
  months: cn('relative flex flex-col'),
  nav: cn('absolute right-0 flex'),
  button_previous: cn('flex rounded-xs px-sm py-xs hover:bg-emphasis-default'),
  button_next: cn('flex rounded-xs px-sm py-xs hover:bg-emphasis-default'),
  month: cn('flex flex-col gap-sm'),
  dropdowns: cn('relative inline-flex items-center gap-xs'),
  dropdown_root: cn(
    'relative flex rounded-xs px-sm py-xs hover:bg-emphasis-default',
  ),
  dropdown: cn(
    'absolute inset-0 z-10 w-full cursor-pointer appearance-none opacity-none',
  ),
  caption_label: cn(
    'relative z-0 inline-flex items-center gap-2xs whitespace-nowrap font-normal leading-6 text-strong-on-dark',
  ),
  chevron: cn('w-md fill-[white]'),
  month_grid: cn('border-separate border-spacing-x-0 border-spacing-y-sm'),
  weekdays: cn('text-strong-on-dark'),
  day: cn('p-0'),
  day_button: cn(
    'w-full p-xs text-center text-body-sm leading-6 text-strong hover:rounded-xs hover:bg-emphasis-strong',
  ),
  selected: cn('bg-emphasis-default text-white'),
  range_start: cn('rounded-l-xs bg-primary-default'),
  range_end: cn('rounded-r-xs bg-primary-default'),
  outside: cn('opacity-stronger'),
};
